type SpinnerProps = {
    'data-testid'?: string
}

const Spinner = ({ 'data-testid': dataTestId = '__spinner__' }: SpinnerProps) => {
    return (
        <div
            data-testid={dataTestId}
            className="h-12 w-12 animate-spin rounded-full border-4 border-t-transparent"
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label="Loading"
        />
    )
}

export default Spinner
